import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import api from "../axiosInstance";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import TaskIcon from "@mui/icons-material/Task";
import DescriptionIcon from "@mui/icons-material/Description"; // For Exam QP
import AssignmentIcon from "@mui/icons-material/Assignment"; // For Internal Assessment
import NotesIcon from "@mui/icons-material/Notes"; // For Notes
import SummarizeIcon from "@mui/icons-material/Summarize"; // For Notes Summary
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DeleteIcon from "@mui/icons-material/Delete";
import BlockIcon from "@mui/icons-material/Block";
import ExpandLess from "@mui/icons-material/ExpandLess";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import TopicIcon from "@mui/icons-material/Topic";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import ExpandMore from "@mui/icons-material/ExpandMore";
import VideocamIcon from "@mui/icons-material/Videocam";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import { Breadcrumbs, Button, Collapse, IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import NavBar from "./NavBar";
import CanAccess from "./access/CanAccess";
import ExamQP from "./BookContent/ExamQP";
import InternalAssessment from "./BookContent/InternalAssessment";
import Notes from "./BookContent/Notes";
import Syllabus from "./BookContent/Syllabus";
import NotesSummary from "./BookContent/NotesSummary";
import Videos from "./BookContent/Videos";
import TipsandTricks from "./BookContent/TipsandTricks";
import { ToastContainer } from "react-toastify";
import EssayQA from "./BookContent/EssayQA";
import ShortQA from "./BookContent/ShortQA";
import TopicWise from "./BookContent/TopicWise";
import VeryShort from "./BookContent/VeryShort";
import QueationsAndAns from "./BookContent/QueationsAndAns";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SIALogo from "../assets/SIALogo.png";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
const drawerWidth = 240;
// side navbar  menu Items
const menuItems = [
  { label: "Exam QP", icon: <DescriptionIcon /> },
  { label: "Internal Assessment", icon: <AssignmentIcon /> },
  { label: "Notes", icon: <NotesIcon /> },
  { label: "Notes Summary", icon: <SummarizeIcon /> },
  { label: "Syllabus", icon: <MenuBookIcon /> },
  { label: "Tips and Tricks", icon: <TipsAndUpdatesIcon /> },
  { label: "Videos", icon: <VideocamIcon /> },
  { label: "Question And Answers", icon: <TaskIcon /> },
];

function BookFiles() {
  const navigate = useNavigate();
  const location = useLocation();
  const { bookId, Booktitle } = location.state || {};
  const [bookContent, setBookContent] = useState([]);
  const [openSubMenu, setOpenSubMenu] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("Exam QP");
  const filtered = bookContent.filter((item) => item.book_part_type_id === 1);
  const [open, setOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  console.log(bookId, Booktitle);
  console.log(bookContent);

  // Submenu Open and close
  const handleSubMenuClick = () => {
    setOpenSubMenu((prev) => !prev);
  };
  //  Book Deatils get Api Fetching
  useEffect(() => {
    api
      .get(`/api/book-files`, {
        params: {
          bookId: bookId,
        },
      })
      .then((res) => setBookContent(res.data))

      .catch((err) => console.error(err));
  }, []);
  return (
    <>
      <NavBar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <ToastContainer />
      <Box sx={{ display: "flex" }}>
        <Drawer
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          variant="permanent"
          sx={{
            display: { xs: "none", md: "flex" },
            width: open ? 70 : 240,
            flexShrink: 0,
            transition: "width 0.3s ease",
            [`& .MuiDrawer-paper`]: {
              width: open ? 70 : 240,
              transition: "width 0.3s ease",
              boxSizing: "border-box",
              mt: "85px",
              height: "calc(100vh - 85px)",
              position: "fixed",
              overflowX: "hidden",
            },
          }}
        >
          <Box sx={{ overflow: "auto" }}>
            <List>
              {/* Regular Menu Items */}
              <CanAccess component="BOOKS_FILES_MENU">
                {menuItems.map(({ label, icon }) => (
                  <ListItem key={label} disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setSelectedMenu(label);
                        setMobileOpen(false);
                      }}
                      sx={{
                        ...(selectedMenu === label && {
                          backgroundColor: "#e3f2fd",
                        }),
                      }}
                    >
                      <ListItemIcon>{icon}</ListItemIcon>
                      <ListItemText primary={label} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </CanAccess>

              {/* Submenu Toggle */}
              {/* <ListItemButton onClick={"Question And Answers"}>
                <ListItemIcon>
                  <TaskIcon />
                </ListItemIcon>
                <ListItemText primary="Question And Answers" />
                {openSubMenu ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton> */}

              {/* Submenu Items */}
              {/* <Collapse in={openSubMenu} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => setSelectedMenu("Essay Q&A")}
                  >
                    <ListItemIcon>
                      <AddToPhotosIcon />
                    </ListItemIcon>
                    <ListItemText primary="Essay Q&A" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => setSelectedMenu("Short Q&A")}
                  >
                    <ListItemIcon>
                      <HourglassTopIcon />
                    </ListItemIcon>
                    <ListItemText primary="Short Q&A" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => setSelectedMenu("Topic wise Q&A")}
                  >
                    <ListItemIcon>
                      <TopicIcon />
                    </ListItemIcon>
                    <ListItemText primary="Topic wise Q&A" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => setSelectedMenu("Very Short Q&A")}
                  >
                    <ListItemIcon>
                      <QuestionAnswerIcon />
                    </ListItemIcon>
                    <ListItemText primary="Very Short Q&A" />
                  </ListItemButton>
                </List>
              </Collapse> */}
              {/* === Drawer Bottom Section === */}
            </List>
          </Box>
          <Box
            sx={{
              p: 2,
              borderTop: "1px solid #e0e0e0",
              display: "flex",
              bottom: "0",
              top: "0px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
            onClick={() => navigate("/booklist")}
          >
            <Button
              startIcon={<ArrowBackIcon />}
              color="primary"
              variant="text"
              sx={{ textTransform: "none", fontWeight: 500 }}
            >
              Back
            </Button>
          </Box>
        </Drawer>
        {/* ===== Mobile Sidebar Drawer ===== */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          sx={{
            display: { xs: "flex", md: "none" },
            [`& .MuiDrawer-paper`]: {
              width: 240,
              boxSizing: "border-box",
              pt: "10px",
            },
          }}
        >
          {/* Sidebar Header / Toggle Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: mobileOpen ? "space-between" : "flex-end",
              alignItems: "center",
            }}
          >
            <IconButton edge="start" color="inherit" aria-label="logo">
              <Box
                component="img"
                src={SIALogo}
                alt="sia logo"
                sx={{ paddingLeft: "8px", width: "40px" }}
              />
            </IconButton>
            <IconButton
              onClick={() => setMobileOpen(!mobileOpen)}
              sx={{
                color: mobileOpen ? "primary.main" : "text.primary",
                transition: "color 0.3s ease, transform 0.3s ease",
                "&:hover": {
                  color: "primary.main",
                  transform: "scale(1.1)",
                },
              }}
            >
              {mobileOpen ? (
                <MenuOpenIcon fontSize="medium" />
              ) : (
                <MenuIcon fontSize="medium" />
              )}
            </IconButton>
          </Box>
          <Box sx={{ overflow: "auto" }}>
            <List>
              {/* Regular Menu Items */}
              <CanAccess component="BOOKS_FILES_MENU">
                {menuItems.map(({ label, icon }) => (
                  <ListItem key={label} disablePadding>
                    <ListItemButton
                      onClick={() => {
                        setSelectedMenu(label);
                        setMobileOpen(false);
                      }}
                      sx={{
                        ...(selectedMenu === label && {
                          backgroundColor: "#e3f2fd",
                        }),
                      }}
                    >
                      <ListItemIcon>{icon}</ListItemIcon>
                      <ListItemText primary={label} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </CanAccess>

              {/* Submenu Toggle */}
              {/* <ListItemButton onClick={"Question And Answers"}>
                <ListItemIcon>
                  <TaskIcon />
                </ListItemIcon>
                <ListItemText primary="Question And Answers" />
                {openSubMenu ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton> */}

              {/* Submenu Items */}
              {/* <Collapse in={openSubMenu} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => setSelectedMenu("Essay Q&A")}
                  >
                    <ListItemIcon>
                      <AddToPhotosIcon />
                    </ListItemIcon>
                    <ListItemText primary="Essay Q&A" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => setSelectedMenu("Short Q&A")}
                  >
                    <ListItemIcon>
                      <HourglassTopIcon />
                    </ListItemIcon>
                    <ListItemText primary="Short Q&A" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => setSelectedMenu("Topic wise Q&A")}
                  >
                    <ListItemIcon>
                      <TopicIcon />
                    </ListItemIcon>
                    <ListItemText primary="Topic wise Q&A" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => setSelectedMenu("Very Short Q&A")}
                  >
                    <ListItemIcon>
                      <QuestionAnswerIcon />
                    </ListItemIcon>
                    <ListItemText primary="Very Short Q&A" />
                  </ListItemButton>
                </List>
              </Collapse> */}
              {/* === Drawer Bottom Section === */}
            </List>
          </Box>
          <Box
            sx={{
              p: 2,
              borderTop: "1px solid #e0e0e0",
              display: "flex",
              bottom: "0",
              top: "0px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
            onClick={() => navigate("/booklist")}
          >
            <Button
              startIcon={<ArrowBackIcon />}
              color="primary"
              variant="text"
              sx={{ textTransform: "none", fontWeight: 500 }}
            >
              Back
            </Button>
          </Box>
        </Drawer>
        <Box component="main" sx={{ flexGrow: 1, p: { xs: 1, md: 3 }, mt: 10 }}>
          <Box>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
              <Link underline="hover" color="inherit" to="/booklist">
                Books List
              </Link>
              <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
                Book Files
              </Typography>
              <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
                {selectedMenu}
              </Typography>
            </Breadcrumbs>
          </Box>
          <Box sx={{ flex: 1, display: "flex" }}>
            <Typography sx={{ color: "#17479e" }}>Book Title : </Typography>
            <Typography sx={{ fontWeight: "600", marginLeft: "10px" }}>
              {Booktitle}
            </Typography>
          </Box>

          {selectedMenu === "Exam QP" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <ExamQP
                ExamQp={bookContent.filter(
                  (item) => item.book_part_type_id === 6
                )}
                setBookContent={setBookContent}
              />
            </Typography>
          )}

          {selectedMenu === "Internal Assessment" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <InternalAssessment
                InternalAssessment={bookContent.filter(
                  (item) => item.book_part_type_id === 14
                )}
                setBookContent={setBookContent}
              />
            </Typography>
          )}

          {selectedMenu === "Notes" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <Notes
                Notes={bookContent.filter(
                  (item) => item.book_part_type_id === 12
                )}
                setBookContent={setBookContent}
              />
            </Typography>
          )}
          {selectedMenu === "Notes Summary" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <NotesSummary
                NotesSummary={bookContent.filter(
                  (item) => item.book_part_type_id === 13
                )}
                setBookContent={setBookContent}
              />
            </Typography>
          )}
          {selectedMenu === "Syllabus" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <Syllabus
                Syllabus={bookContent.filter(
                  (item) => item.book_part_type_id === 3
                )}
                setBookContent={setBookContent}
              />
            </Typography>
          )}
          {selectedMenu === "Tips and Tricks" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <TipsandTricks
                TipsandTricks={bookContent.filter(
                  (item) => item.book_part_type_id === 18
                )}
                setBookContent={setBookContent}
              />
            </Typography>
          )}
          {selectedMenu === "Videos" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <Videos
                Videos={bookContent.filter(
                  (item) => item.book_part_type_id === 15
                )}
                setBookContent={setBookContent}
              />
            </Typography>
          )}
          {/* {selectedMenu === "Question And Answers" && (
            <Typography sx={{ marginTop: "30px" }}>
              <QuestionandandANswer
                Videos={bookContent.filter(
                  (item) => item.book_part_type_id === 15
                )}
                setBookContent={setBookContent}
              />
            </Typography>
          )} */}

          {selectedMenu === "Question And Answers" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <QueationsAndAns
                QandA={bookContent.filter(
                  (item) => item.book_part_type_id === 8
                )}
                setBookContent={setBookContent}
              />
            </Typography>
          )}
          {/* 
          {selectedMenu === "Short Q&A" && (
            <Typography sx={{ marginTop: "30px" }}>
              <ShortQA
                ShortQA={
                  bookContent?.["Question And Answers"]?.[
                    "Short Questions and Answers"
                  ] || []
                }
                setBookContent={setBookContent}
              />
            </Typography>
          )}
          {selectedMenu === "Topic wise Q&A" && (
            <Typography sx={{ marginTop: "30px" }}>
              <TopicWise
                TopicWiseQA={
                  bookContent?.["Question And Answers"]?.[
                    "Topic wise Question And Answer"
                  ] || []
                }
                setBookContent={setBookContent}
              />
            </Typography>
          )}

          {selectedMenu === "Very Short Q&A" && (
            <Typography sx={{ marginTop: "30px" }}>
              <VeryShort
                VeryShortQA={
                  bookContent?.["Question And Answers"]?.[
                    "Very Short Questions and Answers"
                  ] || []
                }
                setBookContent={setBookContent}
              />
            </Typography>
          )} */}
        </Box>
      </Box>
    </>
  );
}

export default BookFiles;
